import instance from 'utils/apiCalls';
import { paramsI, UserFormInterface } from '../../../types/interface';
import { USER_URLS } from './userUrls';
import { userSlice } from './userSlice';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

const { actions } = userSlice;
export const getAllUsers =
  (params?: paramsI) =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(USER_URLS.GET_ALL_USER, {
      params: params
    });
    if (response?.data?.meta?.currentPage === 1) {
      dispatch(
        actions.setUserTotalPages({
          totalPages: response?.data?.meta?.totalPages,
          totalRecords: response?.data?.meta?.totalRecords
        })
      );
    }
    return response;
  };

export const getAllRole = () => async () => {
  const response = await instance.get(USER_URLS.GET_ALL_ROLE);
  return response;
};

export const updateUser = (id: number, data: UserFormInterface) => async () => {
  const response = await instance.put(USER_URLS.UPDATE_USER + `/${id}`, data);
  return response;
};

export const createUser = (data: UserFormInterface) => async () => {
  const response = await instance.post(USER_URLS.CREATE_USER, data);
  return response;
};

export const getSingleUser = (id: number) => async () => {
  const response = await instance.get(`${USER_URLS.GET_SINGLE_USER}/${id}`);
  return response;
};

export const getAllFederalState = (params?: paramsI) => async () => {
  const response = await instance.get(USER_URLS.GET_ALL_FEDERAL_STATE, {
    params: params
  });
  return response;
};
